<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
	
	<div class="d-flex align-items-center">
		 


		<div class="mr-auto">
			<el-form inline ref="form" :model="searchform">
         <el-form-item class="mb-0">
             <el-select v-model="searchform.user_type" :placeholder="$t('searchText.타이틀선택')" size="mini" style="width:150px;" @change="onlineChange">
               <el-option
                      v-for="item in searchform.searchOptions1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>
        <el-form-item class="mb-0">
             <el-select v-model="searchform.value" :placeholder="$t('searchText.타이틀선택')" size="mini" style="width:150px;">
               <el-option
                      v-for="item in searchform.searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>
				

					<el-form-item class="mb-0">
						 <el-input :placeholder="$t('searchText.키워드')"  v-model="searchform.keyword" size="mini" style="width:120px;"></el-input>
					</el-form-item>
				
					<el-form-item class="mb-0">
						<el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button>	
					</el-form-item>
			</el-form>
       
		 
		
			
    		
		</div>
	
	</div>

  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
       border class="mt-2"
       :row-class-name="tableRowUserType"
       :empty-text="$t('tableText.데이타가없습니다')">

 <el-table-column
     label="ID" type="index"
      align="center" width="50">
    </el-table-column>

      <el-table-column label=""  align="center" width="45">

            <template slot-scope="scope">

              <span v-if="scope.row.mem_id==scope.row.m_code" class="bg-success text-white mr-1" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;background:#3e3e3e !important">MST</span>
              <span v-if="scope.row.mem_id==scope.row.s_code" class="bg-success text-white mr-1" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;background:#e54747 !important">{{$t('msg.본사')}}</span>
           <span v-if="scope.row.mem_id==scope.row.b_code" class="bg-success text-white mr-1" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px">{{$t('msg.부본')}}</span>
            <span v-if="scope.row.mem_id==scope.row.a_code" class="bg-primary text-white mr-1" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px">{{$t('msg.총판')}}</span>
            <span v-if="scope.row.mem_id==scope.row.c_code " class="bg-warning text-white mr-1" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px">{{$t('msg.매장')}}</span>
             <span v-if="scope.row.mem_id!=scope.row.a_code && scope.row.mem_id!=scope.row.b_code && scope.row.mem_id!=scope.row.c_code && scope.row.mem_id!=scope.row.s_code && scope.row.mem_id!=scope.row.m_code" class="bg-info text-white mr-1" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px">{{$t('msg.유저')}}</span>
           </template>
        </el-table-column>
             
      <el-table-column v-if="this.sitetype=='4'" :label="$t('nav.아이디')"  prop="mem_id" align="center" width="170">
          <template slot-scope="scope">
            <div :style="{ backgroundColor :scope.row.RaceYN}">
            <span :class="scope.row.mem_status === '0' || scope.row.memState === '-2' ?'text-danger':''" @click="openModel(scope.row.mem_id,'tab1')" style="cursor:pointer">{{ scope.row.mem_id}}</span><br>(<span @click="openAgentModel(scope.row.mem_id)"  style="cursor:pointer">{{ scope.row.mem_name}}</span>)
          </div></template>
        </el-table-column>

       <el-table-column
           align="center"
          prop="memState"
          :label="$t('msg.등급')"
          >
          <template slot-scope="scope">
          <el-select :placeholder="$t('status.선택')" v-model="scope.row.memState" size="mini" style="width:70px" >
              <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
            </el-select>
      </template>
          </el-table-column>

       <el-table-column
        :label="$t('tableText.도메인')"
         prop="mem_email" align="center" >

          <template slot-scope="scope">
             {{scope.row.mem_email}}<br>{{scope.row.game_title}}
          </template>

      </el-table-column>

        <el-table-column
         :label="$t('msg.알본')"
       v-if="this.sitetype==='4' && this.userid=='admin' " prop="admin_id" align="center" >
      </el-table-column>
    
      <template v-if="this.sitetype==='1' ||  this.sitetype==='3'">
       <el-table-column
        :label="$t('tableText.부본사총판추천인')"
       prop="b_code" align="center" >
        <template slot-scope="scope">
          {{scope.row.b_code}}-{{scope.row.a_code}}-{{scope.row.m_cp}}
        </template>
      </el-table-column>
    </template>

    <template v-if="this.sitetype==='4' ">
      <el-table-column
      :label="$t('tableText.부본사총판매장')"
      prop="c_code"  width="180px" align="center" >
        <template slot-scope="scope">
          {{scope.row.b_code}}{{scope.row.bname}}-{{scope.row.a_code}}{{scope.row.aname}}-{{scope.row.c_code}}{{scope.row.cname}}
        </template>
      </el-table-column>
    </template>

    
	  <template v-if="this.aid!='soft10'">
		   <el-table-column
         :label="$t('msg.게임머니')"
      prop="mem_cash" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.mem_cash)}}</template>
      </el-table-column> 

        <el-table-column
        v-if="sitetype=='2'"
        :label="$t('msg.이벤트머니')"
        prop="mem_eventmoney" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.mem_eventmoney)}}</template>
      </el-table-column> 

      <el-table-column
        v-if="sitetype=='4'"
          :label="$t('msg.카지노머니')"
         prop="api_money" align="center">
         <template slot-scope="scope">
          <span class="text-primary">{{ formatMoney(scope.row.api_money)}}</span>
          <el-button type="default" :title="$t('msg.카지노머니')"  size="mini" style="padding:2px;" class="ml-1" icon="el-icon-refresh" @click="apiMoney(scope)"></el-button></template>
      </el-table-column> 

        <el-table-column
         :label="$t('msg.롤링머니')"
        v-if="sitetype=='1' || sitetype=='4'"
       prop="mem_eventmoney" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.mem_eventmoney)}}</template>
      </el-table-column> 
      
      </template>

      <template v-if="this.aid=='soft10' && this.sim!='1'">
       <el-table-column
         :label="$t('msg.알잔액')"
      prop="mem_cash" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.mem_cash)}}</template>
      </el-table-column> 

         <el-table-column
         :label="$t('msg.카슬머니')"
       prop="api_money" align="center">
         <template slot-scope="scope">
          <span class="text-primary">{{ formatMoney(scope.row.api_money)}}</span>
          <el-button type="default" :title="$t('msg.카슬머니')"  size="mini" style="padding:2px;" class="ml-1" icon="el-icon-refresh" @click="apiMoney(scope)"></el-button></template>
      </el-table-column> 
     
        <el-table-column
        :label="$t('msg.카슬롤링')"
         prop="mem_eventmoney" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.mem_eventmoney)}}</template>
      </el-table-column> 

<template v-if="this.power=='1'">
       <el-table-column
         :label="$t('msg.파워머니')"
      prop="power_cash" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.power_cash)}}</template>
      </el-table-column> 

       <el-table-column
         :label="$t('msg.파워롤링')"
         prop="power_ecash" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.power_ecash)}}</template>
      </el-table-column> 
</template>
    
      </template>

       <template v-if="this.aid=='soft10' && this.sim=='1'">
       
       <el-table-column
         :label="$t('msg.게임머니')"
      prop="mem_cash" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.mem_cash)}}</template>
      </el-table-column>   

       <el-table-column
         :label="$t('msg.카슬머니')"
       prop="api_money" align="center">
         <template slot-scope="scope">
          <span class="text-primary">{{ formatMoney(scope.row.api_money)}}</span>
          <el-button type="default" :title="$t('msg.카슬머니')"  size="mini" style="padding:2px;" class="ml-1" icon="el-icon-refresh" @click="apiMoney(scope)"></el-button></template>
      </el-table-column> 
     
        <el-table-column
        :label="$t('msg.롤링머니')"
         prop="mem_eventmoney" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.mem_eventmoney)}}</template>
      </el-table-column> 
    
      </template>

     
<el-table-column
         :label="$t('tableText.충환전')" prop="" align="center" width="130px">
        <template slot-scope="scope">
              <el-button-group>
                <el-button type="success"  size="mini" @click="bonOpen(1,scope.row.mem_id,1)">{{$t('msg.충전')}}</el-button>
                <el-button type="primary"  size="mini" @click="bonOpen(1,scope.row.mem_id,2)">{{$t('msg.환전')}}</el-button>
           </el-button-group>
          </template>
      </el-table-column> 

    

     
<el-table-column
          :label="$t('newAdd.입금출금')"
       prop="in_money" align="center">
         <template slot-scope="scope">
           <div style="text-align:center;">
          {{ formatMoney(scope.row.in_money)}}<br>
          {{ formatMoney(scope.row.out_money)}}</div>
        </template>
      </el-table-column> 
       

        <el-table-column
        :label="$t('newAdd.알충알환')"
       prop="off_in" align="center">
         <template slot-scope="scope">
          <div style="text-align:center;">{{ formatMoney(scope.row.off_in)}}<br>{{ formatMoney(scope.row.off_out)}}</div></template>
      </el-table-column> 
       

      

     
        <!--
        <el-table-column
        
        label="파워볼롤링" prop="event_loing" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.event_loing)}}</template>
      </el-table-column> 
        <el-table-column
        
        label="파워볼조합롤링" prop="event_loing_group" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.event_loing_group)}}</template>
      </el-table-column> 
        <el-table-column
        
        label="사다리롤링" prop="event_loing_s" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.event_loing_s)}}</template>
      </el-table-column> 
-->

       
      <!-- <el-table-column
        
        label="배팅계" prop="mem_all_init" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.mem_all_init)}}</template>
      </el-table-column>-->

      

      
       <el-table-column
          :label="$t('msg.가입일')"
    prop="mem_regdate" align="center">
      </el-table-column> 
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
				  <div style="flex: 1;" class="px-2">
					  <el-pagination
					  :current-page="currentPage"
					  :page-sizes="[5, 10, 15, 20]"
					  :page-size="size"
					  layout="prev, pager, next"
					  :total="total"
					  @size-change="handleSizeChange"
      				  @current-change="handleCurrentChange">
					</el-pagination>
				  </div>
				</el-footer>	
       
				  <div class="dialogLayer" v-show="shareShow" @click="shareShow=!shareShow">
      </div>  
</div>
 </template>

 <script>
 import layer from '../../components/common/layer.vue';
 import layerNew from '../../components/common/layer-new.vue';
import layoutLayer from '../../components/common/layout-layer.vue';
    export default {
     components: {
      layer,layerNew,layoutLayer
    },
    	data(){
    		return{
          up_cash:false,
          shareShow:false,
           level_title:{
             '-2':this.$i18n.t("msg.블랙"),
              '-1':this.$i18n.t("msg.대기"),
              '0':this.$i18n.t("msg.기본")       
            },
          domain:window.sessionStorage.getItem('domain'),
          sitetype:window.sessionStorage.getItem('sitetype'),
          bg:window.sessionStorage.getItem('bg'),
          userid:window.sessionStorage.getItem('userid'),
          aid:window.sessionStorage.getItem('admin_id'),
          power:window.sessionStorage.getItem('power'),
          sim:window.sessionStorage.getItem('sim'),
    		  formLoading:false,
          idDialogVisible: false,
            options: [{
              label: this.$i18n.t("msg.블랙"),
              value: '-2',
             
            }, {
              label: this.$i18n.t("msg.대기"),
               value: '-1',
              
            }, {
              label: this.$i18n.t("msg.기본"),
               value: '0',
             
            }, {
              label: 'v1',
               value: '1',
             
            }, {
              label: 'v2',
               value: '2',
             
            }, {
              label: 'v3',
               value: '3',
             
            }, {
              label: 'v4',
               value: '4',
             
            }, {
              label: 'v5',
               value: '5',
             
            }, {
              label: 'v6',
               value: '6',
             
            }, {
              label: 'v7',
               value: '7',
             
            }, {
              label: 'co',
               value: '8',
             
            }],
    			typeObj:{
              
              
              '-2':this.$i18n.t("msg.블랙"), 
              '-1':this.$i18n.t("msg.대기"),
              '0':this.$i18n.t("msg.기본"),
              '1':'v1',
              '2':'v2',
              '3':'v3',
              '4':'v4',
              '5':'v5',
              '6':'v6',
              '7':'v7',
              '8':'co',
            
 
            },
    			searchform:{
    				keyword:'',
    				time:[],
    				searchOptions:[
                
    				{
		          label:this.$i18n.t("msg.아이디"),
		        	value:'mem_id'
		        },
            {
              label:this.$i18n.t("msg.알본"),
              value:'admin_id'
            }
            

		        ],
		       
            
		        value:'',
            searchOptions1:[
                
            {
              label:this.$i18n.t("msg.전체"),
              value:''
            },
             {
              label:this.$i18n.t("msg.파트너"),
              value:'pt'
            },
             {
              label:this.$i18n.t("msg.유저"),
              value:'user'
            },

            ],
           
            
            user_type:'',

      


    			},
    			 pickerOptions: {
    			},
          shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
    
       
		        
    		
		    		 total:0,
		    		 size:0,
		    		 loading: false,
		    		 editIndex:-1,
		    		 creatModel:false,
		    		 tableData: [],
			         currentPage:1,
			         multipleSelection:[],
			        
			         
			 
    			}
    			
    			
    		},
    		created() {
    			

    			this.getList();
    			
			
		},
   
    	methods:{
         bonOpen(e,id,type){
           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layoutLayer,
                parent: this,
                data:{
                einfo:{e:e},
                info:{id:id,type:type},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['500px', '480px'],
        });
        
        },
         apiMoney(e){

          if(this.up_cash)
          {
return;
          }
          
          this.up_cash=true;
        
          let token=window.sessionStorage.getItem('user');
          let that=this;
          this.$axios({
                      method:'get',
                      url:this.domain+'/admin/getapimoney?mem_id='+e.row.mem_id,
                     
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                         
                  }).then((response) =>{ 

                     this.up_cash=false;
                  
                    if(response.data.code==200){

                       this.$message({
                    message:this.$i18n.t("msg.갱신완료"),
                      type:'success'
                    })
                     
                      e.row.api_money=response.data.data
                    }
                    else{
                      this.$message({
                      message:response.data.msg,
                      type:'error'
                    })
                    }

                    
                  }).catch((error) =>{
                     this.up_cash=false;
                      
                  })
        },
          // 关闭弹框（头部的X）
        handleClose () {
               this.idDialogVisible = false
            },
        cancelData(){
          this.idDialogVisible = false
        },
         cancelEvent(){
          this.shareShow = false
        },
         openModel(id,e){

          if(this.aid=='soft10')
           {
            this.shareShow = true

                this.$layer.iframe({
                type: 2,
                title: id,
                content: {
                    content: layerNew,
                    parent: this,
                    data:{
                    info:{id:id},
                    activeTab:e,
                    layerid:'id'
                    }
                  
                },
              
                shadeClose: true,
                maxmin:true,
                shade: false,
                area: ['1200px', '740px'],
                cancel:()=>{
                  this.shareShow = false
                  console.log(close)
                }
                
             
             });

              return;
           }
           
           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layer,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['830px', '680px'],
         
        });
        },
        tableRowUserType({ row, rowIndex }){

         
         
          if (row.user_type == 'pt') {
            console.log(rowIndex)
            return 'warm-row';
          }else
          {
            return ''
          }
             

        },
        onlineChange(){
            this.getList(); 
        },

    			 // 搜索事件
			searchEvent(){

                if(this.searchform.keyword!='' && this.searchform.value == ''){
                	this.$message(this.$i18n.t("msg.검색타이틀선택하세요"));
                	 return;
                }

              
            


    			this.getList();
    			
             

    		},
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
			    
       
    		getList(){

    		 
             

               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

              
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/admin/online?user_type='+this.searchform.user_type+'&s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword+'&page='+this.currentPage;

    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                     let data = response.data
                     this.tableData =data.data
                     this.total = data.total
                     this.currentPage = data.current_page
                     this.size =data.per_page
                     
                     this.loading =false
               
            }).catch((error) =>{
            
                this.$message.error(error);
              this.loading = false
               
            })
    		},
    		
    		
    	
    		
    	}
  }
</script>

 <style scoped>
/deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 /deep/ .el-dialog{
    height:700px;overflow-y:scroll
 }
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 /deep/ .el-dialog__body{
  padding:10px 20px
 }

 

  .success-row{

    background: green;
  }
</style>


// WEBPACK FOOTER //
// src/views/online/list.vue